import { render, staticRenderFns } from "./GuaranteeOnboardingPrivacyTerms.vue?vue&type=template&id=3f521022&scoped=true&"
import script from "./GuaranteeOnboardingPrivacyTerms.vue?vue&type=script&lang=js&"
export * from "./GuaranteeOnboardingPrivacyTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f521022",
  null
  
)

export default component.exports